<template>
  <div class="eleSetting">
    <el-dialog
        title="报警设置"
        :visible.sync="dialogVisible"
        width="30%">
        
        <el-tabs type="border-card">
        <el-tab-pane label="报警设置">
            <div id="bjsz">
                <div id="bjsz1">
                    <el-radio v-model="form.type" label="1">闯入围栏报警</el-radio>
                    <el-radio v-model="form.type" label="2">离岗报警</el-radio>
                </div>
                 <div id="bjsz2">
                    <el-radio v-model="form.type" label="3">违规停车&nbsp;&nbsp;&nbsp;&nbsp;</el-radio>
                     <el-radio v-model="form.type" label="4">超时滞留</el-radio>
                </div>
                
               
                <div id="timeInput">
                <el-input placeholder="请输入时长" v-model="form.uplimit">
                    <template slot="append">秒</template>
                </el-input>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="选择对象">
            <div id="xzdx">
                  
                 <el-checkbox-group v-model="checkList"  @change="selectBox">

                    <el-checkbox v-for="(item,i) in workers" :key="i" :value="item.deviceNo" :label="item.personName+' '+item.deviceNo"></el-checkbox>
                </el-checkbox-group>
            </div>
        </el-tab-pane>
            
        </el-tabs>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="doSet()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<style scoped>
#xzdx{
    max-height: 400px;
    overflow-y: auto;
}
</style>
<script>
import {getAllHisWorker} from "@/api/worker.js"
import {updateElectronWarn} from "@/api/ele.js"

  export default {
    
    props:{
    },
    data() {
        
      return {
        values:[],
          checkList:[],
          workers:[],
          form:{
              electron:undefined,//电子围栏编号
              type:undefined,//报警类型
              uplimit:undefined,//时长
              warnType:2,
              visWarn:0,
              conWarn:0,
              warnWorks:[]
          },
        dialogVisible: false
      };
    },
    methods: {
      selectBox(val){
         this.values = [];
         debugger
      val.forEach(item=>{
        const value = item.split(' ')[1];
        this.values.push(value);
      });
      },
    doSet(){
      let warnWorks=[]
      for(let i=0;i<this.values.length;i++){
        warnWorks.push({
          "id":this.values[i],
          "type":0
        })
      }
      this.form.warnWorks=warnWorks
      let _this=this
      if(!this.form.uplimit){
        this.$message.error("时长必填")
        return
      }
      updateElectronWarn(this.form).then(res=>{
        _this.$message.success("设置成功")
        _this.$parent.doSearch()
      })
    },
    getWorkers(){
        let username=this.username=this.D3Config.username
        let password=this.password=this.D3Config.password
        let _this=this
        getAllHisWorker(username,password).then((res)=>{
            _this.workers=res.data.data.rows;
        })
    },
    toggle(row){
        this.form.electron=row.electron
        this.dialogVisible=!this.dialogVisible
        if(this.dialogVisible){
            this.getWorkers()
        }
    },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    }
  };
</script>